module.exports = __webpack_public_path__ + "img/south-america.3bbb41f8.png";